export default {
  SET_CONFIG: (state, config = null) => { state.config = config },
}
